import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { EngagementMeeting } from '../models/get-engagement-conference';

export const FetchEngagementConferences = createAsyncThunk(
    'engagementMeetings/fetch',
    async (engagementId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/Marketplace/Engagements/${engagementId}/EngagementMeetings`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch engagement meetings at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch engagement meetings');
            }

            return response.data as EngagementMeeting[];
        } catch (error) {
            createNotification(
                'An error occurred while fetching engagement meetings.',
                'error'
            );
            throw error;
        }
    }
);

